import { useState } from 'react';
import AccordionRow from './AccordionRow';

const Accordions = ({
  DesignSystemComponents,
  items = [],
  disabled = false,
}) => {
  const initialIndex = items.findIndex((i) => i.defaultOpen);

  const [activeIndex, setActiveIndex] = useState(
    initialIndex !== -1 ? initialIndex : null
  );

  return (
    <>
      {items.map((item, index) => (
        <div key={index}>
          <AccordionRow
            DesignSystemComponents={DesignSystemComponents}
            index={index}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            title={item.title}
            disabled={disabled}
          >
            {item.content}
          </AccordionRow>
          <hr className='line' />{' '}
        </div>
      ))}
    </>
  );
};

export default Accordions;
